import * as React from 'react';
import { MailFolderList } from 'owa-mail-folder-view';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import { getMailRootFolderChildIds } from 'owa-folders';
import mailStrings from 'owa-strings/owa-mail-strings';
import { observer } from 'mobx-react';
import { lazyToggleFolderTreeExpansion } from 'owa-mail-folder-store';
import { lazyDeleteFolderInFolderForest } from 'owa-mail-folder-forest-actions';
import folderNameToId from 'owa-session-store/lib/utils/folderNameToId';
import { isFolderUnderDeletedItemsFolder } from 'owa-mail-store';
import { getPrimaryMailboxRootFolder, getMailboxLoadingState, PRIMARY_FOLDER_ROOT_DISTINGUISHED_ID, PRIMARY_DELETED_ITEMS_DISTINGUISHED_ID, PRIMARY_FOLDERS_TREE_TYPE, } from 'owa-folders';
/**
 * Primary mailbox container
 */
function PrimaryMailFolderTreeContainer(props) {
    // Primary mailbox root click handler
    var onRootNodeChevronClicked = function () {
        lazyToggleFolderTreeExpansion.importAndExecute();
    };
    var onDeleteFolder = function (folder, actionSource) {
        var primaryDeletedItemsFolderId = folderNameToId(PRIMARY_DELETED_ITEMS_DISTINGUISHED_ID);
        var isFolderUnderDeletedItemFolder = isFolderUnderDeletedItemsFolder(folder, PRIMARY_DELETED_ITEMS_DISTINGUISHED_ID);
        lazyDeleteFolderInFolderForest.importAndExecute(folder.FolderId.Id, actionSource, primaryDeletedItemsFolderId, isFolderUnderDeletedItemFolder);
    };
    return (React.createElement(MailFolderList, { className: props.className, key: "primarymailboxtree", showRootNode: props.showRootNode, rootFolder: getPrimaryMailboxRootFolder(), isRootExpanded: !getUserConfiguration().UserOptions.IsMailRootFolderTreeCollapsed, rootDisplayName: mailStrings.Folders, childFolderIds: getMailRootFolderChildIds('primary'), onRootNodeChevronClickedCallback: onRootNodeChevronClicked, treeType: PRIMARY_FOLDERS_TREE_TYPE, isFavoritesSupported: true, onDeleteFolderCallback: onDeleteFolder, loadingState: getMailboxLoadingState(PRIMARY_FOLDER_ROOT_DISTINGUISHED_ID) }));
}
export default observer(PrimaryMailFolderTreeContainer);
//# sourceMappingURL=PrimaryMailFolderTreeContainer.js.map